'use client'
import { InfoIcon } from '../../icons'
import React, { ReactElement, ReactNode, useId } from 'react'
import { ITooltip as ReactToolTipProps, Tooltip as ReactTooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'

/** Prop variant is omitted because only default variant is styled */
export interface TooltipProps extends Omit<ReactToolTipProps, 'variant' | 'content'> {
    id?: string
    content: string | React.ReactNode
    filled?: boolean
    children?: ReactNode
}

export const Tooltip = ({ id, content, filled = false, children, ...rest }: TooltipProps): ReactElement => {
    const uniqueId = id ?? useId()

    return (
        <div className="tooltip" data-testid="tooltip">
            {!children && (
                <InfoIcon
                    data-tooltip-id={uniqueId}
                    className={`tooltip__icon tooltip__icon--filled-${filled ? 'true' : 'false'}`}
                />
            )}

            {children && (
                <div data-tooltip-id={uniqueId} data-testid="tooltip-children">
                    {children}
                </div>
            )}

            <ReactTooltip {...rest} id={uniqueId} className="contrast z-50">
                {content}
            </ReactTooltip>
        </div>
    )
}
